import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { EncryptionString } from '../../models/encryption-string.model';

const ENCRYPTION_ENDPOINT = 'encryption';

@Injectable({
  providedIn: 'root',
})
export class EncryptionBackendService {
  constructor(private http: HttpClient) {}

  public getEncryptedString(text: string) {
    return this.http.get<EncryptionString>(
      AppConfig.settings.backend.url +
        ENCRYPTION_ENDPOINT +
        `?webApp=${true}&parameter=` +
        encodeURIComponent(text)
    );
  }
}
